// extracted by mini-css-extract-plugin
export var container = "styles-module--container--NJiZo";
export var orderedListItem = "styles-module--orderedListItem--sEkED";
export var unorderedListItem = "styles-module--unorderedListItem--rkLO9";